<div
  [ngClass]="{
    'ultrawide:h-[212px]': navigationId === 'sky-miles',
    'h-[90vh]': isAlertAdvisory
  }"
  class="secondary-nav mt-[24px] laptop:mt-0 desktop:mt-0 px-[16px] py:-[16px] justify-center laptop:flex items-start laptop:h-[260px] laptop:w-[100vw] laptop:pl-[32px] laptop:pr-[71px] laptop:pt-[40px] laptop:pb-[32px] ultrawide:h-[248px] ultrawide:py-[40px]"
>
  <div
    class="secondary-nav__primary-list ultrawide:h-[168px]"
    id="mach-core-secondary-nav-primary-list"
  >
    <ul
      class="secondary-nav__primary-item flex flex-col gap-[12.19px] text-inverse"
      id="mach-core-secondary-nav-primary-ul"
    >
      <li
        class="flex gap-[12px]"
        *ngFor="let navItem of content.details.mainNavigation; let x = index"
        id="mach-core-secondary-nav-primary-item-{{ x }}"
      >
        <img
          class="hidden laptop:block"
          [src]="navItem.imagePathDesktop"
          [alt]="navItem.altText"
        />
        <a
          class="!text-inverse whitespace-nowrap text-label-sm-semibold"
          (click)="
            setTrackingObject(content.id, navItem.brandLabel, navItem.targetUrl)
          "
          (keydown)="onKeyPress($event)"
          [attr.href]="navItem.targetUrl"
          [attr.target]="navItem?.openInNewTab ? '_blank' : '_self'"
          id="mach-core-secondary-nav-primary-link-{{ x }}"
        >
          {{ navItem.brandLabel }}
        </a>
      </li>
    </ul>
  </div>
  <div
    [ngClass]="{
      'laptop:h-[132px]': navigationId === 'sky-miles',
      'laptop:h-[180px] ultrawide:h-[168px]': navigationId === 'secondarynav',
      'laptop:h-[164px] ultrawide:h-[168px]': navigationId === 'more'
    }"
    class="hidden laptop:block !border !border-stroke-03 laptop:mx-[72px] ultrawide:mx-[96px]"
  ></div>
  <div
    [ngClass]="{
      'laptop:w-[522px]': navigationId === 'secondarynav',
      'laptop:w-[557px]': navigationId === 'sky-miles',
      'laptop:w-fit': navigationId === 'more',
      'ultrawide:w-[634px]': navigationId === 'more',
      'ultrawide:w-[738px]':
        navigationId === 'secondarynav' || navigationId === 'sky-miles',
      'ultrawide:h-[148px]': navigationId === 'secondarynav',
      'ultrawide:h-[84px]': navigationId === 'sky-miles',
      'ultrawide:h-[116px]': navigationId === 'more'
    }"
    class="secondary-nav__pages mt-[24px] laptop:mt-0"
    id="mach-core-secondary-nav-pages"
  >
    <ul
      [ngClass]="{
        'ultrawide:grid-cols-4 ultrawide:grid-rows-5':
          navigationId === 'secondarynav',
        'ultrawide:grid-cols-4 ultrawide:grid-rows-3':
          navigationId === 'sky-miles',
        'ultrawide:grid-cols-3 ultrawide:grid-rows-4': navigationId === 'more',
        'laptop:grid-cols-3 laptop:grid-rows-4':
          navigationId === 'sky-miles' || navigationId === 'more',
        'laptop:grid-cols-3 laptop:grid-rows-6': navigationId === 'secondarynav'
      }"
      class="flex flex-col laptop:grid laptop:grid-flow-col gap-y-[12px] gap-x-[46px] text-body-xs text-inverse"
      id="mach-core-secondary-nav-pages-ul"
    >
      <li
        [ngClass]="{
          'items-center': childPage.externalImage
        }"
        class="flex gap-x-[2px]"
        *ngFor="let childPage of this.content.details.childPages; let y = index"
        id="mach-core-secondary-nav-pages-item-{{ y }}"
      >
        <a
          (click)="
            setTrackingObject(content.id, childPage.pageName, childPage.pageUrl)
          "
          (keydown)="onKeyPress($event)"
          [attr.href]="childPage.pageUrl"
          [attr.target]="childPage.openInNewTab ? '_blank' : '_self'"
          id="mach-core-secondary-nav-pages-link-{{ y }}"
          class="laptop:flex items-center whitespace-nowrap !text-inverse"
          [ngClass]="{
            'gap-[2px]': childPage.externalImage
          }"
        >
          {{ childPage.pageName }}
        </a>
        <svg
          *ngIf="childPage.externalImage"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 1.5V8.10156H9.2998V3.49219L2.34863 10.501L1.5 9.64551L8.3877 2.7002H3.89941V1.5H10.5Z"
            fill="white"
          />
        </svg>
      </li>
    </ul>
  </div>
</div>
